module.exports = __webpack_public_path__ + "img/rock.a0f676b8.webp";